import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import {
  SurveyInstanceDTO,
  CreateSurveyInstanceDTO,
  SurveyInstanceListDTO,
  SurveyInstanceStatsDTO,
  CreateInstanceResponseDTO,
} from '../dtos';

export const surveyInstanceApi = {
  // Create a new survey instance
  create: async (
    surveyId: string,
    data: CreateSurveyInstanceDTO
  ): Promise<ApiResponse<CreateInstanceResponseDTO>> => {
    const response = await apiClient.post<CreateInstanceResponseDTO>(
      `/surveys/${surveyId}/instances`,
      data
    );
    return response;
  },

  // Get instances for a survey
  getBySurveyId: async (
    surveyId: string,
    limit: number = 5
  ): Promise<ApiResponse<SurveyInstanceListDTO>> => {
    const response = await apiClient.get<SurveyInstanceListDTO>(
      `/surveys/${surveyId}/instances?limit=${limit}`
    );
    return response;
  },

  // Get a specific instance
  getById: async (
    surveyId: string,
    instanceId: string
  ): Promise<ApiResponse<SurveyInstanceDTO>> => {
    const response = await apiClient.get<SurveyInstanceDTO>(
      `/surveys/${surveyId}/instances/${instanceId}`
    );
    return response;
  },

  // Get instance statistics for a survey
  getStats: async (surveyId: string): Promise<ApiResponse<SurveyInstanceStatsDTO>> => {
    const response = await apiClient.get<SurveyInstanceStatsDTO>(
      `/surveys/${surveyId}/instances/stats`
    );
    return response;
  },
};
